<template>
	<div>
		<fab
			:main-icon="fab.icon"
			:position="fab.position"
			:bg-color="fab.bgColor"
			:actions="fab.fabActions"
			:fixed-tooltip="fab.tooltip"
			@visibility="visibility"
			@add="addBudget"
			@edit="edit"
			@search="search">
		</fab>

		<search ref="search" :user="user" :isAuth="isAuth" @reload="reload"></search>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import fab from 'vue-fab'
	import Search from '@/components/search/layout/Search'
	export default {
		props: ['user', 'isAuth', 'data', 'type'],
		components: {
			fab,
			'search': Search,
		},
		created() {
			this.init()
		},
		data () {
			return {
				fab: {
					icon: 'reorder',
					bgColor: '#1cb9f2',
					position: 'bottom-right',
					fabActions: null,
					tooltip: true,
				}
			}
		},
		watch: {
			data() {
				this.loadActions()
			},
		},
		methods: {
			init() {
				this.loadActions()
			},
			loadActions() {
				var actions = []
				actions.push({
					tooltip: 'Ver',
					name: 'visibility',
					icon: 'visibility',
				})
				if(this.data) {
					if(!this.data.lock) {
						actions.push({
							tooltip: 'Editar',
							name: 'edit',
							icon: 'mode_edit',
						})
					}
				}
				actions.push({
					tooltip: 'Añadir',
					name: 'add',
					icon: 'add',
				})
				actions.push({
					tooltip: 'Buscar',
					name: 'search',
					icon: 'search',
				})
				if(this.type == 'show') {
					var actions = []
					if(!this.data.lock) {
						actions.push({
							tooltip: 'Editar',
							name: 'edit',
							icon: 'mode_edit',
						})
					}
					actions.push({
						tooltip: 'Añadir',
						name: 'add',
						icon: 'add',
					})
					actions.push({
						tooltip: 'Buscar',
						name: 'search',
						icon: 'search',
					})
				}
				if(this.type == 'edit') {
					var actions = [
						{
							tooltip: 'Ver',
							name: 'visibility',
							icon: 'visibility',
						},
						{
							tooltip: 'Añadir',
							name: 'add',
							icon: 'add',
						},
						{
							tooltip: 'Buscar',
							name: 'search',
							icon: 'search',
						},
					]
				}
				if(this.type == 'index') {
					var actions = [
						{
							tooltip: 'Añadir',
							name: 'add',
							icon: 'add',
						},
						{
							tooltip: 'Buscar',
							name: 'search',
							icon: 'search',
						},
					]
				}

				this.fab.fabActions = actions
			},
			edit() {
				this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/budgets/' + this.data.id + '/edit')
			},
			visibility() {
				this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/budgets/' + this.data.id)
			},
			search() {
				this.$refs.search.open('budgets')
			},
			reload() {
				this.$emit('reload')
			},
			editOrContinue(response) {
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/budgets/' + response.body.data.id + '/edit')
				}).catch()
			},
			addBudget () {
				var that = this
				var data = {}
				if(this.data) {
					data.customer_id = this.data.customer_id
				}
				swal.queue([{
					title: this.$t("messages.attention"),
					text: this.$t("messages.budget_will_be_created"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.post('admin/management/budgets', data)
							.then(response => {
								that.$emit('reload')
								that.editOrContinue(response)
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
				/*
				this.$http.post('admin/management/budgets')
				.then(response => {
					this.$emit('reload')
					this.editOrContinue(response)
				}).catch(function(response) {
					console.log(response)
				})
				*/
			},
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/management/budgets/views/Fab.vue